import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { customBaseURL, customHeaders, indianProjectsBaseURL, uaeProjectsBaseURL } from '../../../../Containers/Config/index.js';
import { GET_CLIENT_AIRPORT, GET_CLIENT_AIRPORT_SUCCESS, GET_CLIENT_AIRPORT_ERROR } from './../../actionType.js';
import apiCall from '../../apiCall';
import cogoToast from 'cogo-toast';
import { Constant } from '../../../../Containers/Helpers/constant.js';

function* getClientAirport({ payload }) {
  try {
    const response = yield call(apiCall, {
      url: `${uaeProjectsBaseURL}/vendor/airports`,
      method: 'GET',
      headers: {
        Authorization: Constant?.CLIENT_TOKEN,
        // ...customHeaders,
        'project-code': 'MASTERCARD_KSA',
      },
      params: {
        ...payload?.urlParam,
        pageSize: Constant?.TABLE_PAGE_SIZE,
      },
    });

    if (response.status === 200) {
      yield put({
        type: GET_CLIENT_AIRPORT_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: GET_CLIENT_AIRPORT_ERROR,
        payload: response?.data?.message,
      });
    }
  } catch (error) {
    yield put({ type: GET_CLIENT_AIRPORT_ERROR, payload: error });
  }
}

export function* watchGetClientAirport() {
  yield takeEvery(GET_CLIENT_AIRPORT, getClientAirport);
}

function* getClientAirportSaga() {
  yield all([fork(watchGetClientAirport)]);
}

export default getClientAirportSaga;
